import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BarcodeIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 24 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <rect x="2" y="4" width="2" height="16" />
      <rect x="5" y="4" width="1" height="16" />
      <rect x="7" y="4" width="2" height="16" />
      <rect x="10" y="4" width="1" height="16" />
      <rect x="12" y="4" width="1" height="16" />
      <rect x="14" y="4" width="2" height="16" />
      <rect x="17" y="4" width="1" height="16" />
      <rect x="19" y="4" width="1" height="16" />
      <rect x="21" y="4" width="1" height="16" />
    </g>
  </svg>
);

BarcodeIcon.propTypes = propTypes;

export default BarcodeIcon;
